import moment from 'moment';

// birthdate format: 2000-12-12T00:00:00+00:00
export const calculateAge = (birthdate) => moment().diff(birthdate, 'years');
